import 'swiper/css';
import '../scss/main.scss';
import '../components/slider-swiper';

import {
  btnAddToCart,
  deleteItem,
  onChangeItemCart,
  openCloseCart,
  recommendedProduct,
} from '../components/cart';
import { setQuantity } from '../utils/input-quantity';
import { startTimer } from '../components/timer';
import { validationBtn } from '../components/modifyBtn';
import { initProduct } from '../components/product';

initProduct();
recommendedProduct();
btnAddToCart('.form[data-type="add-to-cart-form"]');
btnAddToCart('.add-product-cart-upsell');
btnAddToCart('.AddToCartProductDiscount');

const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get('view');

// AB TEST
if (myParam === 'new') {
  btnAddToCart('.AddToCartForm');
}

openCloseCart();
deleteItem();
setQuantity();
onChangeItemCart();
startTimer();
validationBtn();

console.log('klajsdhaskdjhsadijnh')
